import { useComponentContext } from './ComponentContext'

function ComponentSwitch({ type, ...props }: any) {
  const componentContext = useComponentContext()
  if (!componentContext) {
    throw new Error('Component context is not provided')
  }
  if (componentContext.availableComponents[type] !== undefined) {
    const Comp = componentContext.availableComponents[type]
    return (
      <Comp
        {...props}
        metadata={props.metadata}
        answer={props.answer ? props.answer : (props?.id && componentContext.answers[props?.id]) || null}
      />
    )
  }
  return null
}

export default ComponentSwitch
